import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {ConceptSelection, DisplayField} from '@twpub/core/models';
import {NGXLogger} from 'ngx-logger';
import {ConceptService, VirtualFileService} from '@twpub/core/services';
import {CardImageComponent} from '../card-image/card-image.component';

import {FieldRenderComponent} from '../../../../../shared/components/renders/field-render/field-render.component';

@Component({
  selector: 'pub-card-content',
  templateUrl: './card-content.component.html',
  styleUrls: ['./card-content.component.scss'],
  standalone: true,
  imports: [CardImageComponent, FieldRenderComponent]
})
export class CardContentComponent implements OnInit, OnChanges {
  @Input() conceptId?: number;
  @Input() termId?: number;
  @Input() imageFields?: string[] = []
  @Input() displayFields?: DisplayField[] = [];
  fileIds: number[] = [];

  constructor(private logger: NGXLogger, private conceptService: ConceptService,
              private virtualFileService: VirtualFileService) {
  }

  ngOnInit(): void {
    this.findFileIds();
  }

  ngOnChanges(): void {
    this.findFileIds();
  }

  private findFileIds() {
    if (this.conceptId) {
      this.conceptService.getConcept(this.conceptId).subscribe({
        next: (concept) => {
          const term = concept.terms.filter(t => t.id === this.termId).pop();
          this.fileIds = this.virtualFileService.getImages(concept, term, this.imageFields);
        }
      })
    } else {
      this.fileIds = [];
    }
  }

  selectConcept(selection: ConceptSelection) {
    this.logger.warn('CardContentComponent.selectConcept called - not expected', {selection});
  }
}
